import React from "react";
import PropTypes from "prop-types";
import {
    Form,
    FormGroup,
    Label,
    Input,
    Col,
    Button,
} from "reactstrap";

/**
 * Price Selector Edit Form Component
 */
const PriceSelectorEditForm = ({
    store_domain,
    created_at,
    onInputChange,
    onSubmit,
}) => {
    return (
        <Form onSubmit={onSubmit}>
            <FormGroup className="row mb-4">
                <Label
                    htmlFor="horizontal-store_domain-Input"
                    className="col-sm-1 col-form-label text-md-right"
                    style={{ textAlign: "center" }}
                >
                    Store Domain
                </Label>
                <Col sm={2}>
                    <Input
                        value={store_domain}
                        type="text"
                        name="store_domain"
                        className="form-control"
                        id="horizontal-store_domain-Input"
                        readOnly
                    />
                </Col>
            </FormGroup>
            <FormGroup className="row mb-4">
                <Label
                    htmlFor="horizontal-created_at-Input"
                    className="col-sm-1 col-form-label text-md-right"
                    style={{ textAlign: "center" }}
                >
                    Created At
                </Label>
                <Col sm={2}>
                    <Input
                        value={created_at}
                        type="date"
                        name="created_at"
                        className="form-control"
                        id="horizontal-created_at-Input"
                        onChange={onInputChange}
                        required
                    />
                </Col>
            </FormGroup>
            <FormGroup className="row justify-content-end">
                <Col sm={11}>
                    <div>
                        <Button
                            type="submit"
                            color="primary"
                            className="w-md"
                        >
                            Update
                        </Button>
                    </div>
                </Col>
            </FormGroup>
        </Form>
    );
};

PriceSelectorEditForm.propTypes = {
    store_domain: PropTypes.string.isRequired,
    created_at: PropTypes.string.isRequired,
    onInputChange: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
};

export default PriceSelectorEditForm;

